export default {
      id: "about-symbols-07-usage",
      viewBox: "0 0 150 150",
      url: "/" + "sprite.svg#about-symbols-07",
      toString: function () {
        return this.url;
      }
    }